import * as React from 'react';

import { v4 as uuidv4 } from 'uuid';

import {InstancePropertyFormWidget} from 'kiini/Forms';
import {FormConfigurations} from 'kiini/Forms';
import TextField from 'kiini/TextField';
import ObjectListWithPanel from 'kiini/ObjectListWithPanel';

import { 
    ButtonConfiguration,
    CommandAction,
    UIConfigurations,
    ImageElement
} from 'model/contentObjects'

import OptionalOneOfField from 'kiini/OptionalOneOfField'

import { NOTIFY_OR_SHOW_ASSIGNMENT } from 'components/engineEventHandlers/constEventHandlers'
import FileAssetElementWidget from 'components/storyblocks/FileAssetElementWidget'
import ShowGamePointActionWidget from './action-widgets/ShowGamePointActionWidget';

import { imageElementInitialData } from 'components/fileAssets/const'

import ImageElementWidget from 'components/storyblocks/ImageElementWidget'
import BooleanField from 'kiini/BooleanField';

const ShowGamePointActionFieldWidget = ({instance, store, fieldName})=>{
    // explanation, widget normally get instance and fieldname and retrieve themselves the related instance 
    // (so it can eventuelly set a field null)
    // for some reason the ShowGamePointActionWidget is using direct the related instance, so we wrapp it 
    const actionInstance = instance[fieldName]
    return ShowGamePointActionWidget({instance: actionInstance, store})

}

const roleFormsConfigurationData = {

    'content_objects.model.ButtonConfiguration':{
        label: "Button",
        fields: [
            {
                fieldName: "label", 
                label: "Label", 
                widget: TextField
            },
            {
                fieldName: "action", 
                label: "Action", 
                widget: ShowGamePointActionFieldWidget
            },
            {
                fieldName: "buttonId", 
                label: "Button Id", 
                widget: TextField
            },
            {
                fieldName: "enabled", 
                label: "Enabled", 
                widget: BooleanField
            },
            { 
                fieldName: "image",
                    label: "Image",
                    widget: OptionalOneOfField,
                    widgetProps: {
                        createItem: () => (new ImageElement(null, {id: uuidv4(), ...imageElementInitialData}))
                    }
            },
            
        ]   
    },
    'content_objects.roles.UIConfigurations':{
        groups:  [
            {
                label: "UI configuration",
                fields: [
                    {
                        fieldName: "buttonConfigurations", 
                        label: "Map buttons", 
                        widget: ObjectListWithPanel, 
                        widgetProps: {
                            createItem: () => { 
                                const buttonConfiguration = new ButtonConfiguration(null, {id: uuidv4()})
                                buttonConfiguration.placement = "default"
                                buttonConfiguration.enabled = true
                                buttonConfiguration.buttonId = "button_1"
                                buttonConfiguration.action = new CommandAction(
                                        null, {
                                        id: uuidv4(),
                                        alias:  NOTIFY_OR_SHOW_ASSIGNMENT,
                                        command: NOTIFY_OR_SHOW_ASSIGNMENT,
                                        values: {
                                        }
                                    });
                                return buttonConfiguration
                            }
                        }
                    },
                ]   
            }
        ]       
    },
    "content_objects.model.ImageElement": {
        widget: ImageElementWidget,
        label: "Image",

    },
}


export const contentRoleFormConfigurations = new FormConfigurations(roleFormsConfigurationData);



const UIRolesClazzNames = [
    'content_objects.roles.UIConfigurations',
]; 

const uiRolesCreationOptions = {
    
    
    'content_objects.roles.UIConfigurations': {
        label: "Map button configuration", 
        creator: () => (new UIConfigurations(null, {id: uuidv4(), buttonConfigurations: []}))
    },
}


const UiElementsForm = ({instance, store}) => {
    return <InstancePropertyFormWidget 
    instance={instance} 
    store={store}
    fieldName="contentRoles"
    label="UI elements"
    Widget={ObjectListWithPanel}
    widgetProps={{
        creationOptions: uiRolesCreationOptions,
        itemFilterFuction: instance =>  UIRolesClazzNames.some( name => name === instance.$classDescription.clazzName),
        oneInstancePerClassInList: true,
    }}
    formConfigurations={contentRoleFormConfigurations}/>
}


export default UiElementsForm;